module.exports = __webpack_public_path__ + "static/WhenThePastWasAround0-541820973766542db6ae9eaccc863c91.webp";